module.exports = __webpack_public_path__ + "img/building-04.2008f98e.webp";